import React, {Fragment} from 'react';
import { getFromLocalStorage } from "../../utils/localStorage";

export default class DeliveryModeBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      takeAwaySelected: false,
    };
  }

  componentDidMount() {
    if (!window) { return; }

    if(JSON.parse(getFromLocalStorage('take_away')) === true) {
      this.setState({
        takeAwaySelected: true
      });
    }
  }

  render(props) {
    const { isDelivery, isOwnDelivery, venueName } = this.props;
    const {takeAwaySelected} = this.state;
    const isHybridDelivery = isDelivery && isOwnDelivery;

    if(!takeAwaySelected && ! isDelivery && !isOwnDelivery ) {
      return null;
    }

    return (
      <div className="delivery-box">
        {takeAwaySelected &&
          <Fragment>
            <div className="icon">
              <i className="fal fa-person-carry" />
            </div>
            <div className="details">
              <h6>
                {I18n.t("pages.venues.show.venue_details.delivery_type_takeaway_title")}
              </h6>
              <p>
                {I18n.t("pages.venues.show.venue_details.delivery_type_takeaway_description")}
              </p>
            </div>
          </Fragment>
        }
        {isHybridDelivery  && !takeAwaySelected &&
        <Fragment>
          <div className="icon">
            <i className="fal fa-biking" />
          </div>
          <div className="details">
            <h6>
              {I18n.t("pages.venues.show.venue_details.delivery_type_hybrid_delivery_title")}
            </h6>
            <p>
              {I18n.t("pages.venues.show.venue_details.delivery_type_hybrid_delivery_description")}
            </p>
          </div>
        </Fragment>
        }
        {isOwnDelivery && !takeAwaySelected && !isHybridDelivery &&
        <Fragment>
          <div className="icon">
            <i className="fal fa-biking" />
          </div>
          <div className="details">
            <h6>
              {I18n.t("pages.venues.show.venue_details.delivery_type_only_own_delivery_title", {venue_name: venueName})}
            </h6>
            <p>
              {I18n.t("pages.venues.show.venue_details.delivery_type_only_own_delivery_description")}
            </p>
          </div>
        </Fragment>
        }
      </div>
    )
  };
}
